var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar',{attrs:{"title":_vm.fad,"box":_vm.box}}),_vm._v(" "),_c('van-divider',{staticStyle:{"color":"white"}},[_vm._v("Siparişiniz Başarı ile alındı")]),_vm._v(" "),_c('van-popup',{model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('van-loading',{attrs:{"type":"spinner","color":"#fff"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e84a69dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/siparis.vue
// module id = null
// module chunks = 